export default __webpack_public_path__ + "static/media/MeasureBG.6bb50459.png";